import omit from 'lodash/omit';
import groupBy from 'lodash/groupBy';
import { sdkRequest } from 'js-utils/http';

/**
 * Maps the array of regions to a hash by country code
 *
 * @param {*} regions
 */
const mapRegionsByCountry = (regions) => groupBy(regions, 'country_code');

/**
 * Raises the nested mobile expansion parameters to be toplevel params for the
 * country endpoint
 *
 * @param countries
 * @returns {*}
 * @private
 */
const _deinflateMobile = (countries) =>
    countries.map((country) => ({
        ...omit(country, 'mobile'),
        ...country.mobile,
    }));

/**
 * Fetches all the regions in the entirety of the world, then maps by country.
 * Returns a promise that resolves with a map of country code to a list of
 * region objects like yea:
 *
 * {
 *    US: [{code: 'AL', label: 'Alabama', country_code: 'US'}, ...],
 *    CA: [...],
 *    ...
 * }
 *
 * @returns {Promise}
 */
export const fetchRegions = () =>
    sdkRequest('/api/v3/system/regions/').then((response) => ({
        ...response,
        regions: mapRegionsByCountry(response.regions),
    }));

/**
 * Fetch the countries supported by Eventbrite. Returns a promise that resolves
 * with an array of country objects like yea:
 *
 * [
 *     {
 *         code: 'AF',
 *         label: 'Afghanistan',
 *         zip_required: false
 *     },
 *     ...
 * ]
 *
 * @returns {Promise}
 */

export const fetchCountries = () =>
    sdkRequest('/api/v3/system/countries/?expand=mobile').then((response) => ({
        ...response,
        countries: _deinflateMobile(response.countries),
    }));
